import React, { Fragment, useContext, useEffect, useState, useRef } from "react";
import { connect, useDispatch } from 'react-redux';
import { Link, useHistory, useLocation } from 'react-router-dom';
import {
    Row,
    Col,
    Card,
    Table,
    Modal,
    Button,
    Accordion,
    Spinner
} from "react-bootstrap";

const SheetReviewModal = (props) => {


    return (
        <Fragment>
            <Modal
                className="fade bd-example-modal-sm"
                size="sm"
                show={props.show}
            >
                <div className='add-subcription-plan'>
                    <h3>{props.title}</h3>
                    <h4>{props.description}</h4>
                    <div className='subcription-plan-btn-group'>
                        <button
                            type="button"
                            onClick={props.onClose}
                            className="btn form-cencel-btn">
                            Cancel
                        </button>
                        <button
                            type="button"
                            onClick={props.onSubmit}
                            className="btn confirm-btn">
                            OK
                        </button>
                    </div>

                </div>
            </Modal>
        </Fragment>
    )
}

export default SheetReviewModal